import {DataGridPro} from '@mui/x-data-grid-pro'
import {envImagePath} from 'GLOBAL/envVariables'
import DeviceDetailInfoModal from 'pages/common/DeviceDetailInfoModal'
import DeviceTargetImageListModal from 'pages/common/DevicetargetImageListModal'
import {deviceInfoColumns} from 'pages/device/dataConfig/declearColumns'
import {deviceInfoFilter} from 'pages/device/dataConfig/declearFilters'
import {deviceInfoRows} from 'pages/device/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getDeviceInfo} from 'utils/apiCalling/api'
import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {scrollTop} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'

const DeviceInfo = (props: any) => {
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  const [loading, setLoading] = useState<boolean>(false)
  const [deviceInfoList, setDeviceInfoList] = useState<any>(null)
  const [deviceDetailData, setDeviceDetailData] = useState<any>(null)
  const [totalCount, setTotalCount] = useState<any>(null)
  const [imageDetailOpen, setImageDetailOpen] = useState<boolean>(false)
  const [deviceDetailOpen, setDeviceDetailOpen] = useState<boolean>(false)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [filter, setFilter] = useState<any>(deviceInfoFilter)
  const [rows, setRows] = useState<any[]>([])
  const imageDetailModalOpen = () => {
    setImageDetailOpen(true)
  }
  const imageDetailModalClose = () => {
    setImageDetailOpen(false)
  }
  const deviceDetailModalOpen = () => {
    setDeviceDetailOpen(true)
  }
  const deviceDetailModalClose = () => {
    setDeviceDetailOpen(false)
  }
  const getDeviceInstallListCall = () => {
    getDeviceInfo(officeInfo, cooperInfo, filter, {
      success: (res: any) => {
        setDeviceInfoList(res)
      },
      count: (count: any) => {
        setTotalCount(count)
      },
      fail: (error: any) => {
        console.log(error)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }

  const columns: any = deviceInfoColumns(
    setDeviceDetailData,
    deviceDetailModalOpen,
    imageDetailModalOpen
  )

  const getRowHeightOnDataGrid = (params: any) => {
    const {imageHeight} = params?.model || {}
    // 매핑 테이블
    const heightMap: Record<number, number> = {
      480: 290,
      240: 260,
      144: 190,
    }

    if (imageHeight && heightMap[imageHeight]) {
      return heightMap[imageHeight]
    }
    // 기본값
    return 180
  }

  useEffect(() => {
    scrollTop()
    getDeviceInstallListCall()
  }, [
    filter.deviceStatus,
    filter.efosStatus,
    filter.deviceType,
    filter.batteryStatus,
    filter.cooperIdx,
    filter.page,
    filter.rowPerPage,
    cooperInfo,
    officeInfo,
  ])

  useEffect(() => {
    if (deviceInfoList) {
      setRows(deviceInfoRows(deviceInfoList))
    }
  }, [deviceInfoList])

  useEffect(() => {
    if (!rows.length) return

    rows.forEach((row) => {
      if (row.filePath && !row.imageWidth) {
        const img = new Image()
        img.src = envImagePath + row.filePath
        img.onload = () => {
          setRows((prev) =>
            prev.map((r) =>
              r.id === row.id && !r.imageWidth
                ? {...r, imageWidth: img.width, imageHeight: img.height}
                : r
            )
          )
        }
      }
    })
  }, [rows]) // rows가 바뀌었을 때만 실행

  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.deviceInfo.description}
        tooltipText={toolTipText.deviceInfo.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'device-info'}
        setFilter={setFilter}
        searchCallback={getDeviceInstallListCall}
        total={totalCount}
        control={['device', 'battery', 'efos', 'deviceType']}
        actions={[]}
        onDelete={null}
        searchOptions={['serialNumber', 'imei', 'deviceVersion']}
        checkData={null}
        onCancel={null}
      >
        <DataGridPro
          rowHeight={190}
          getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
          rows={rows}
          autoHeight={true}
          columns={columns}
          disableColumnMenu
          checkboxSelection={false}
          loading={loading}
          paginationMode={'server'}
          hideFooterPagination={true}
          pagination={true}
          hideFooter={true}
        />
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>
      <DeviceTargetImageListModal
        data={deviceDetailData}
        open={imageDetailOpen}
        onClose={imageDetailModalClose}
      />
      <DeviceDetailInfoModal
        data={deviceDetailData}
        open={deviceDetailOpen}
        onClose={deviceDetailModalClose}
        getList={getDeviceInstallListCall}
      />
    </>
  )
}

export default DeviceInfo
